import React from 'react';
import './styles.css';
import techimg from "../assets/headphones-with-microphone-call-center-office-desk.jpg";


function About() {
  return (
    <section id="about" className="about">
      <div className="about-container">
        <div className="section-title">
          <h2>À Propos de Nous</h2>
          <p>Découvrez l'histoire et les valeurs qui font de STOA Consulting un partenaire technologique de confiance.</p>
        </div>
        <div className="about-content">
          <div className="about-image">
            <div>
                <img className='image' src={techimg} alt="" />
            </div>
          </div>
          <div className="about-text">
            <h3>Notre Histoire</h3>
            <p>Fondée en 2024, STOA Consulting est née de la passion commune de ses fondateurs pour la technologie et l'innovation. Nous avons commencé comme une petite équipe de développeurs dévoués et avons grandi pour devenir une entreprise de solutions technologiques complète.</p>
            
            <h3>Notre Mission</h3>
            <p>Chez STOA Consulting, notre mission est de fournir des solutions technologiques innovantes et accessibles qui aident les entreprises à se transformer et à prospérer dans l'ère numérique. Nous nous engageons à créer des technologies qui font une différence réelle.</p>
            
            <h3>Nos Valeurs</h3>
            <ul className="values-list">
              <li><span>Innovation</span> - Nous repoussons constamment les limites du possible.</li>
              <li><span>Qualité</span> - Nous ne faisons jamais de compromis sur l'excellence.</li>
              <li><span>Intégrité</span> - Nous agissons avec honnêteté et transparence.</li>
              <li><span>Collaboration</span> - Nous croyons en la puissance du travail d'équipe.</li>
            </ul>
            
            <button className="btn primary-btn">Notre Équipe</button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;